import React from 'react'

const PrivacyContent: React.FC = () => {
  return (
    <div className="text-gray-700 text-sm leading-relaxed">

      <h3 className="text-lg font-bold text-gray-900 mb-4">AVISO DE PRIVACIDAD (LFPDPPP MÉXICO)</h3>
      <p className="mb-2 text-xs text-gray-500">Última actualización: Enero 2025</p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1. Identidad y Domicilio del Responsable</h4>
      <p className="mb-4">
        Rubén Rodríguez González, persona física, operando bajo el nombre comercial InnovaAgent,
        con domicilio en Coahuila, México, es responsable del tratamiento de los datos personales
        proporcionados por los usuarios de la plataforma InnovaAgent.
        Contacto: contacto@bdctech.com.mx
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">2. Datos Personales que se Recopilan</h4>
      <p className="mb-2">Datos de identificación: Nombre completo, teléfono, correo electrónico, empresa o agencia inmobiliaria.</p>
      <p className="mb-2">Datos de actividad: Propiedades registradas, leads gestionados, resultados de campañas, interacciones en el sistema, ubicación aproximada.</p>
      <p className="mb-2">Datos técnicos: Dirección IP, tipo de dispositivo, cookies de navegación, estadísticas de uso del sistema.</p>
      <p className="mb-4">No recolectamos datos sensibles: estado de salud, información financiera privada, datos biométricos, creencias religiosas o políticas.</p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">3. Finalidades del Tratamiento</h4>
      <p className="mb-2">Finalidades principales: Crear y administrar cuentas, gestionar accesos, brindar servicios del ecosistema InnovaAgent, automatizar segmentación y análisis, proveer soporte técnico, cumplir obligaciones legales.</p>
      <p className="mb-4">Finalidades secundarias: Enviar información sobre actualizaciones, ofrecer promociones, elaborar estudios internos de uso. El usuario puede solicitar dejar de recibirlas en cualquier momento.</p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">4. Uso de Cookies</h4>
      <p className="mb-4">
        InnovaAgent utiliza cookies y tecnologías similares para autenticar usuarios, recordar preferencias
        y analizar métricas de uso. El usuario puede desactivarlas desde su navegador.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">5. Transferencia de Datos</h4>
      <p className="mb-4">
        InnovaAgent no vende ni comparte datos personales con terceros. Los datos pueden transferirse a
        proveedores tecnológicos (hosting, almacenamiento, IA) y autoridades legales cuando sea requerido.
        Algunos proveedores se encuentran en Estados Unidos, lo que implica transferencia internacional de datos.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">6. Derechos ARCO</h4>
      <p className="mb-4">
        El usuario puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición enviando
        solicitud a contacto@bdctech.com.mx. Tiempo de respuesta: máximo 20 días hábiles conforme a la LFPDPPP.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">7. Medidas de Seguridad</h4>
      <p className="mb-4">
        InnovaAgent implementa cifrado SSL/HTTPS, backups automáticos, accesos restringidos y control de roles.
        Ningún sistema digital puede garantizar seguridad absoluta.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">8. Revocación del Consentimiento</h4>
      <p className="mb-4">
        El usuario puede revocar su consentimiento enviando solicitud a contacto@bdctech.com.mx.
        Esto podría limitar el uso del sistema.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">9. Cambios al Aviso</h4>
      <p className="mb-4">
        Cualquier modificación será notificada a través de la plataforma con al menos 30 días de anticipación.
      </p>

      <div className="bg-blue-50 p-4 rounded-lg mt-6 mb-4">
        <p className="text-blue-800 text-center text-sm">
          Responsable: Rubén Rodríguez González · Nombre comercial: InnovaAgent
          · Coahuila, México · contacto@bdctech.com.mx
        </p>
      </div>

    </div>
  )
}

export default PrivacyContent
